<ui-modal
  uiModalPortal
  [isOpen]="isOpen"
  size="medium"
  [growVertically]="false"
  [disableOverlayClose]="true"
  position="center"
  (onClose)="close()"
  (isOpenChange)="isOpenChange.emit($event)"
>
  <div class="file-rename-modal">
    <div class="file-rename-modal__header">
      <h3 class="file-rename-modal__title">{{ "uploads.Rename_file" | translate }}</h3>
    </div>
    <div class="file-rename-modal__body">
      <label class="file-rename-modal__label">
        {{ "upload-details-slider.File_Name" | translate }} <span class="file-rename-modal__required">*</span>
      </label>
      <input
        #nameInput
        type="text"
        class="file-rename-modal__input"
        [(ngModel)]="editingValue"
        (ngModelChange)="errorKey = null"
        (keydown.enter)="confirm()"
      />
      @if (errorKey) {
        <p class="file-rename-modal__error">{{ errorKey | translate }}</p>
      }
    </div>
    <div class="file-rename-modal__actions">
      <ui-button
        variant="primary"
        size="large"
        [fullWidth]="true"
        [disabled]="submitting"
        [label]="'uploads.Rename_file' | translate"
        (clicked)="confirm()"
      ></ui-button>
      <ui-button
        variant="tertiary"
        size="large"
        [fullWidth]="true"
        [disabled]="submitting"
        [label]="'settings.Cancel' | translate"
        (clicked)="close()"
      ></ui-button>
    </div>
  </div>
</ui-modal>
